/**
 * @fileoverview Style constants for AssignProjectModal
 * Only contains custom styles not available in Mantine's default theme
 */

export const COLORS = {
  // Brand indigo under Arc; legacy green preserved via the var() fallback
  primary: 'var(--arc-primary, #20927d)',
  primaryHover: 'var(--arc-primary-hover, #1b7d6b)',
  // Soft (10% alpha) primary for hover backgrounds — a dedicated var because
  // appending '10' to the primary var() would produce invalid CSS
  primarySoft: 'var(--arc-primary-soft, #20927d10)',
} as const

export const SPACING = {
  modal: 24,
  modalMobile: 16,
  section: 20,
  element: 16,
  small: 8,
} as const

export const CARD_STYLES = {
  backgroundColor: '#f8f9fa',
  borderRadius: 12,
}

export const INPUT_STYLES = {
  root: { width: '100%' },
  input: {
    height: 48,
    borderRadius: 8,
    fontSize: 15,
    '&:focus': { borderColor: COLORS.primary },
  },
}

export const SEARCH_INPUT_STYLES = {
  input: { backgroundColor: 'white' },
}

export const SCROLL_STYLES = {
  scrollbar: { '&[data-orientation="vertical"]': { width: 6 } },
  thumb: { backgroundColor: '#d0d0d0' },
}

export const getModalStyles = (isMobile: boolean, modalPadding: number) => ({
  content: {
    overflow: 'hidden',
    height: isMobile ? '100%' : '70vh',
    maxHeight: isMobile ? '100%' : '70vh',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  title: {
    fontSize: isMobile ? 18 : 22,
    fontWeight: 600,
    letterSpacing: '-0.3px',
  },
  header: {
    padding: `${modalPadding}px ${modalPadding}px ${SPACING.element}px`,
    marginBottom: 0,
  },
  body: {
    padding: 0,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    overflow: 'hidden',
    flex: 1,
  },
  close: {
    color: '#666',
    '&:hover': { backgroundColor: '#f5f5f5' },
  },
})

export const getButtonStyles = (isMobile: boolean) => ({
  cancel: {
    root: {
      height: isMobile ? 44 : 40,
      px: 20,
      '&:hover': { backgroundColor: '#f5f5f5' },
    },
    label: { fontWeight: 600 },
  },
  save: {
    root: {
      height: isMobile ? 44 : 40,
      px: 24,
      backgroundColor: COLORS.primary,
      '&:hover': { backgroundColor: COLORS.primaryHover },
      '&:disabled': { backgroundColor: '#e0e0e0' },
    },
    label: { fontWeight: 600 },
  },
})
